import { useEffect, useState } from "react"
import { Modal, ModalFooter, ModalHeader, ModalBody, Label, Button } from "reactstrap"
import DateTimePicker from 'react-datepicker'
import ApiService from "../../services/apiService"

import { toast } from "react-toastify"
import DatePicker from "react-datepicker"


type Scheduel = {


  totalValves: number,
  
  ChakId: number,


}
const ScheduelPopup = ({  totalValves,  ChakId }: Scheduel) => {

  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>()
  const [selectedValves, setSelectedValves] = useState<number[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isEnable, setIsEnable] = useState<boolean|string>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>()
  const [weekDay, setWeekDays] = useState<number | string>()
  const [valveNo, setValveNo] = useState<number | string>()
  const [volume, setVolume] = useState<string | number>()
  const [scheduelNo, setScheduelNo] = useState<string | number>()
  const [duration, setDuration] = useState<string | number>()
  const [startTime, setStartTime] = useState<string | number>()
  const [time, setTime] = useState<Date | null>(null);


  const FULL_VALVE_COUNT = 14;


  const postScheduel = async () => {

    try {
      const response = await ApiService.axiosApi(`/scheduelq`, {
        method: 'POST',
        data: {

          ScheduleNo: scheduelNo,
          EnableDisable: isEnable,
          StartDate: startDate,
          EndDate: endDate,
          StartTime:time,
          Duration: duration,
          Weekdays: weekDay,
          Volume: volume,
          ChakId: ChakId,
          ValveNo: valveNo,
          Status:0

        }
      })
      if (response.success) {
          toast.success('Scheduel Successfully')
           
        } else {
        console.log(response.message||response.status)
        toast.error("Unable To Scheduel")
      }
    } catch (e) {
      console.log(e)
    }
  }

  //toggle
  const handleToggle = (e: any) => {
    setIsChecked(e.target.checked);

    e.target.checked ? setIsEnable(true) : setIsEnable(false)
   
  }
  
  // Day Sequence
  const days = [
    { name: 'Sun', bitIndex: 0 },
    { name: 'Sat', bitIndex: 1 },
    { name: 'Fri', bitIndex: 2 },
    { name: 'Thur', bitIndex: 3},
    { name: 'Wed', bitIndex: 4 },
    { name: 'Tue', bitIndex: 5 },
    { name: 'Mon', bitIndex: 6 }
  ]

  const [selectedDays, setSelectedDays] = useState<number[]>([]);

  const handleCheckboxChange = (bitIndex: number, checked: boolean) => {
    let updated = checked
      ? [...selectedDays, bitIndex]
      : selectedDays.filter((i) => i !== bitIndex);

    setSelectedDays(updated);

  };

  useEffect(() => {
    const bitSequence = Array(7)
      .fill(0)
      .map((_, i) => (selectedDays.includes(i) ? 1 : 0))
      .join("");
  
    setWeekDays(bitSequence);
    
  }, [selectedDays]);
  
 
 console.log(weekDay)

  //ValveSequence

  const handleChange = (index: number, checked: boolean) => {
    const updated = checked
      ? [...selectedValves, index]
      : selectedValves.filter((i) => i !== index);

    setSelectedValves(updated);
  };
  
  useEffect(()=>{
     
    const bitValveSequence = Array(FULL_VALVE_COUNT)
    .fill(0)
    .map((_, i) => (selectedValves.includes(i) ? 1 : 0))
    .join("");
    
    console.log(bitValveSequence)
    setValveNo(bitValveSequence)

  },[selectedValves])
  

  return (
    <>

      
        
      
          <div className='d-flex justify-content-start align-items-center mx-2'>
            <label htmlFor="toggle" className="me-1">Enable:</label>
            <label className="toggle-switch" id="toggle">

              <input type="checkbox"
                checked={isChecked}
                onChange={handleToggle} />
              <span className="slider"></span>
            </label>

          </div>
          <div className='d-flex align-items-center justify-content-between mx-2 my-3'>
            <div className=" input-border d-flex flex-column volume-part1" style={{ paddingRight: '5px' }}>
              <Label>Start Date:</Label>
              <DateTimePicker
                className="volume-scheduel always-bordered"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                onChange={(date: any) => setStartDate(date)}
                selected={startDate}
                isClearable
                timeFormat="HH:mm:ss"
                showTimeSelect

              />
            </div>
            <div className=" input-border d-flex flex-column volume-part1" style={{ paddingRight: '5px' }}>
              <Label>End Date:</Label>
              <DateTimePicker
                className="volume-scheduel always-bordered"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setEndDate(date)}
                selected={endDate}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>

            <DatePicker
  className="volume-scheduel always-bordered"
  dateFormat="dd/MM/yyyy HH:mm:ss"
  placeholderText="DD-MM-YYYY"
  selected={time}
  onChange={(value) => {
    // If cleared
    if (!value) {
      setTime(null);
      return;
    }

    // If value is Date
    if (value instanceof Date && !isNaN(value.getTime())) {
      setTime(value);
      return;
    }

    // If value is string or anything else → INVALID → ignore
    console.warn("Invalid date from DatePicker:", value);
    setTime(null);
  }}
  isClearable
  timeFormat="HH:mm:ss"
  showTimeSelect
/>




          </div>

          <div className='d-flex align-items-center justify-content-center mx-2 my-4'>
            {days.map((day) => (
              <div className=' d-flex align-items-center px-2' key={day.bitIndex}>
                <input type="checkbox"
                  className='native-circle me-2'
                  id={`day-${day.name}`}
                  onChange={(e) => { handleCheckboxChange(day.bitIndex, e.target.checked) }}
                />
                <label className="form-check-label" htmlFor={`day-${day.name}`}>
                  {day.name}
                </label>
              </div>
            ))}
          </div>


          <div className="d-flex align-items-center justify-content-between mx-2 my-3">
            <div className="input-border d-flex flex-column volume-part1" style={{ paddingRight: '5px' }}>
              <Label>ScheduleNo:</Label>
              <input
                type="text"
                className="volume-scheduel always-bordered "
                onChange={(e:any)=>setScheduelNo(e.target.value)} />
            </div>


            <div className="input-border  d-flex flex-column volume-part1 " style={{ paddingRight: '5px' }}>
              <Label>Duration:</Label>
              <input
                type="text"
                className="volume-scheduel always-bordered"
                onChange={(e:any)=>setDuration(e.target.value)}
              />
            </div>
            <div className="input-border d-flex flex-column volume-part1">
              <Label>Volume:</Label>
              <input
                type="text"
                className="volume-scheduel always-bordered p-2"
                onChange={(e:any)=>setVolume(e.target.value)}
              />
            </div>
          </div>



          <div className="d-flex align-items-center justify-content-center my-4 ">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {Array.from({ length: totalValves }, (_, i) => (
                <div className="d-flex align-items-center px-2" key={i}>
                  <input
                    className="native-circle me-2"
                    type="checkbox"
                    id={`valve-${i}`}
                    onChange={(e) => handleChange(i, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`valve-${i}`}>
                    V{i + 1}
                  </label>
                </div>
              ))}
            </div>
          </div>


        
        <ModalFooter>
          <div>
            <Button color="primary" onClick={postScheduel}>
              Schedule
            </Button>
          </div>

        </ModalFooter>


    </>

  )
}

export default ScheduelPopup;